











































































import utils from '@/utils.coffee'
import filters from "@/filters.coffee"
import settings from "@/settings.coffee"
import mutations from '@/gql/mutations.coffee'

export default {
    name: 'EstablishmentCard'
    components: {}
    props: {
        establishment: Object
    }
    data: ()->
        return {
        }
    computed: {
        imageSrc: () ->
            ret = ''
            if this.establishment.logo? and this.establishment.logo != ""
                ret = this.establishment.logo
            return settings.backendMediaUrl + ret
    }
    methods: {
        "upload_call_back":(img_data, img_name)->
            uid = this.establishment.uid
            return mutations.run("establishment_update_logo",
                    [uid, img_data, img_name])
        "upload_image": (image)->
            if not image?
                return
            self = this
            reader = new FileReader()
            reader.onload = (aImg)->
                self.upload_call_back(aImg.target.result, image.name)
            reader.readAsDataURL(image)      
        "filesChanged": (arg, arg2, arg3)->
            self = this
            if arg2[0].size < 2000000
                self.upload_image(arg2[0])
            else
                self.$store.dispatch("notify",{
                    level: "danger",
                    text: "Cet image est trop lourde"
                })
    }
    mounted: ()->
        return 
    beforeDestroy: ()->
        return 
}
